const envToBool = (envVar: string | undefined): boolean => envVar?.toLowerCase() === 'true'

const envToBoolOrNull = (envVar: string | undefined): boolean | null =>
  !envVar ? null : envVar.toLowerCase() === 'true'

export enum FeatureFlagName {
  SSO_LOGIN = 'SSO_LOGIN',
  MAINTENANCE_MODAL = 'MAINTENANCE_MODAL',
  SERVICE_NOTIFICATION = 'SERVICE_NOTIFICATION',
}

export const FeatureFlagKey: Record<FeatureFlagName, string> = {
  [FeatureFlagName.SSO_LOGIN]: process.env.REACT_APP_FEATURE_FLAG_SSO_LOGIN_KEY,
  [FeatureFlagName.MAINTENANCE_MODAL]: process.env.REACT_APP_FEATURE_FLAG_MAINTENANCE_MODAL_KEY,
  [FeatureFlagName.SERVICE_NOTIFICATION]: process.env.REACT_APP_FEATURE_FLAG_SERVICE_NOTIFICATION_KEY,
} as const

export const FeatureFlagDefault: Record<FeatureFlagName, boolean> = {
  [FeatureFlagName.SSO_LOGIN]: envToBool(process.env.REACT_APP_FEATURE_FLAG_SSO_LOGIN_DEFAULT),
  [FeatureFlagName.MAINTENANCE_MODAL]: envToBool(process.env.REACT_APP_FEATURE_FLAG_MAINTENANCE_MODAL_DEFAULT),
  [FeatureFlagName.SERVICE_NOTIFICATION]: envToBool(process.env.REACT_APP_FEATURE_FLAG_SERVICE_NOTIFICATION_DEFAULT),
} as const

export const FeatureFlagDevOverride: Record<FeatureFlagName, boolean | null> = {
  [FeatureFlagName.SSO_LOGIN]: envToBoolOrNull(process.env.REACT_APP_FEATURE_FLAG_SSO_LOGIN_DEV_OVERRIDE),
  [FeatureFlagName.MAINTENANCE_MODAL]: envToBoolOrNull(
    process.env.REACT_APP_FEATURE_FLAG_MAINTENANCE_MODAL_DEV_OVERRIDE,
  ),
  [FeatureFlagName.SERVICE_NOTIFICATION]: envToBoolOrNull(
    process.env.REACT_APP_FEATURE_FLAG_SERVICE_NOTIFICATION_DEV_OVERRIDE,
  ),
} as const
